import { InitExpression } from '../InitExpression.js';
import { DeriveExpression } from '../DeriveExpression.js';
import { Utils } from '../../Utils.js';
import { ContextExpression } from './ContextExpression.js';
export class PropertyContextExpression extends ContextExpression {
    constructor(targetType, rules) {
        super();
        const split = targetType.split('::');
        this.targetType = split[0];
        this.propertyName = split[1];
        if (!(rules instanceof Array)) {
            rules = [rules];
        }
        this.inits = rules.filter(i => i instanceof InitExpression);
        this.derived = rules.filter(i => i instanceof DeriveExpression);
    }
    getInits() {
        return this.inits;
    }
    getDerived() {
        return this.derived;
    }
    getPropertyName() {
        return this.propertyName;
    }
    accept(visitor) {
        return Utils.getClassName(visitor.getObjectToEvaluate()) === this.targetType;
    }
    evaluate(visitor) {
        super.evaluate(visitor);
        this.getInits().forEach(init => {
            visitor.getObjectToEvaluate()[this.getPropertyName()] = init.evaluate(visitor);
        });
        this.getDerived().forEach(derive => {
            visitor.getObjectToEvaluate()[this.getPropertyName()] = derive.evaluate(visitor);
        });
        return true;
    }
}
//# sourceMappingURL=PropertyContextExpression.js.map